import { render, staticRenderFns } from "./Label.vue?vue&type=template&id=a274cd96"
import script from "./Label.vue?vue&type=script&lang=js"
export * from "./Label.vue?vue&type=script&lang=js"
import style0 from "./Label.vue?vue&type=style&index=0&id=a274cd96&prod&lang=scss"
import style1 from "./Label.vue?vue&type=style&index=1&id=a274cd96&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports